export default __webpack_public_path__ + "static/media/SingleArrowback.99fd8fc5.svg";